// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClaimCard_cardField__W2JhU{
    width: 100%;
    background: transparent;
    text-align: right;
}

.ClaimCard_cardField__W2JhU:focus-visible {
    border: 0;
    outline: 0;
}

.ClaimCard_cardFieldLabel__2oaUK{
    min-width: 150px;
    text-align: left;
}

`, "",{"version":3,"sources":["webpack://./src/components/ClaimCard.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".cardField{\n    width: 100%;\n    background: transparent;\n    text-align: right;\n}\n\n.cardField:focus-visible {\n    border: 0;\n    outline: 0;\n}\n\n.cardFieldLabel{\n    min-width: 150px;\n    text-align: left;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardField": `ClaimCard_cardField__W2JhU`,
	"cardFieldLabel": `ClaimCard_cardFieldLabel__2oaUK`
};
export default ___CSS_LOADER_EXPORT___;
